import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadNotificationCenterData } from './redux';
import NotificationCenter from '../../components/NotificationCenter';

class WithNotificationCenter extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      multiBreakingNews: PropTypes.arrayOf(PropTypes.shape()),
    }),
    loadNotificationCenterData: PropTypes.func.isRequired,
    theme: PropTypes.string,
    colorTheme: PropTypes.string,
  };
  static defaultProps = {
    data: undefined,
    theme: '',
    colorTheme: '',
  };

  componentDidMount() {
    this.props.loadNotificationCenterData();
  }
  render() {
    const { data } = this.props;
    /*
    let newS = s;
    if (this.props.NotifcationCss) {
      newS = this.props.NotifcationCss;
    }
    */

    if (
      data &&
      Array.isArray(data.multiBreakingNews) &&
      data.multiBreakingNews.length
    ) {
      return (
        <NotificationCenter
          data={data.multiBreakingNews}
          theme={this.props.theme}
          colorTheme={this.props.colorTheme || ''}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  data: state.notificationCenter.data,
});

const mapDispatchToProps = dispatch => ({
  loadNotificationCenterData: params => {
    dispatch(loadNotificationCenterData(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  WithNotificationCenter,
);
